import { computed, defineComponent, h, reactive, toRef } from 'vue';

import { useProvideSummary } from '../../context';

import type { TSummaryFlattenColumns } from '../../context';
import type { NTable } from '../../interface';

interface IFooterProps<RecordType = NTable.TDefaultRecord> {
  stickyOffsets: NTable.NSticky.IStickyOffsets;
  flattenColumns: TSummaryFlattenColumns<RecordType>;
}

export default defineComponent<IFooterProps>({
  // eslint-disable-next-line vue/no-reserved-component-names
  name: 'Footer',
  inheritAttrs: false,
  props: ['stickyOffsets', 'flattenColumns'] as any,
  setup(props, { slots }) {
    useProvideSummary(
      reactive({
        stickyOffsets: toRef(props, 'stickyOffsets'),
        flattenColumn: toRef(props, 'flattenColumns'),
        scrollColumnIndex: computed(() => {
          const lastColumnIndex = props.flattenColumns.length - 1;
          const scrollColumn = props.flattenColumns[lastColumnIndex];
          return scrollColumn?.scrollbar ? lastColumnIndex : null;
        })
      })
    );

    return () => h('tfoot', { class: 'cds-table__summary' }, slots.default?.());
  }
});
